import React from "react";
import { Box, Skeleton } from "@chakra-ui/react";
import Header from "../Header";

const Body = ({ children, title, isLoading = false }) => {
  return (
    <>
      {isLoading ? (
        <>
          <Skeleton height="100px" mb="2rem" />
          <Skeleton height="400px" mx="1rem" />
        </>
      ) : (
        <>
          <Header title={title}></Header>
          <Box maxW={"1440px"} m={"0 auto"} p="1rem">
            {children}
          </Box>
        </>
      )}
    </>
  );
};

export default Body;
